<template></template>
<script type="text/javascript">
export default {
	name: 'ScrollEvents',
	props: {
		inhibit: { // flag to disable interaction from parent (e.g. waiting for an animation to finish)
			type: Object,
			required: false,
			default() { return { up: false, down: false } },
		},
		scrollContainerSelector: {
			type: String,
			required: false,
			default: null
		},
		scrollThreshold: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			scrollArray: [],
			inertia: false,
			latestDirection: undefined, // is 'down' or 'up'
			latestTs: undefined,
			refractory: false,
			lastTouchEvent: '',
			refractoryPeriodMs: 250,
			touchDeltaThreshold: 10
		}
	},
	computed: {
		busy() {
			return this.refractory || this.inertia;
		},
		isTouchDevice() {
			return window.matchMedia("(pointer: coarse)").matches
		}
	},
	watch: {
		inertia(n, o) {
			this.$emit('inertia-status', n);
		},
		refractory(n, o)  {
			this.$emit('refractory-status', n);
		}
	},
	methods: {
		onWheel(event) {
			// console.log("onWheel")
			// event.preventDefault();
			const deltaY = event.deltaY;
			this.scrollArray.push({time: new Date().getTime(), value: Math.abs(deltaY)});
			this.handleScroll(deltaY);
		},
		handleScroll(deltaY, fromKeyEvent) {
			if (this.busy || Math.abs(deltaY) < this.scrollThreshold) return false;
			const direction = deltaY > 0 ? 'down' : 'up';
			if (this.inhibit[direction]) {
				const x = this.inhibit[direction];
				if (fromKeyEvent && typeof x === 'function') x(direction);
				return false;
			}
			
			this.latestDirection = direction;

			this.$emit('scroll-event', this.latestDirection);
			this.refractory = true;
			if (!this.isTouchDevice && !fromKeyEvent) {
				this.inertia = true;
				this.latestTs = new Date().getTime();
				requestAnimationFrame(this.checkInertia);
			} else {
				setTimeout(this.reset, this.refractoryPeriodMs)
			}
		},
		checkInertia() {
			//refractory period
			if (new Date().getTime() - this.latestTs < this.refractoryPeriodMs) {
				requestAnimationFrame(this.checkInertia);
				return;
			}
			this.refractory = false;				

			const accelerating = this.scrollArray.length > 2 && 
								this.scrollArray[this.scrollArray.length-1].value > 
								this.scrollArray[this.scrollArray.length-2].value &&
								this.scrollArray[this.scrollArray.length-2].value > 
								this.scrollArray[this.scrollArray.length-3].value

			if ( accelerating ) {
				this.reset();
			} else {

				if (this.scrollArray.length) {
					const timeDiff = new Date().getTime() - this.scrollArray[this.scrollArray.length-1].time;
					if (timeDiff > 100) {
						this.refractory = true;
						setTimeout(this.reset, 500); //wait for the deceleration phase to finish
						return;
					}					
				}

				requestAnimationFrame(this.checkInertia);
			}
		},
		reset() {
			this.refractory = false;
			this.inertia = false;
			this.scrollArray = [];			
		},
		touchstartCb(e) {
			this.lastTouchEvent = e.type;
			this.updateDeltasTouches(e);
			this.updatePrevTouches(e);
			if(this.busy) e.preventDefault();
		},
		updateDeltasTouches(e) {
			this.deltaY = this.prevY - e.touches[0].clientY;
		},
		updatePrevTouches(e) {
			this.prevY = e.touches[0].clientY;
		},
		touchendCb(e) {
			if(this.lastTouchEvent == 'touchstart') return
			if (Math.abs(this.deltaY) >= this.touchDeltaThreshold) this.handleScroll(this.deltaY);
		},
		touchmoveCb(e) {
			this.lastTouchEvent = e.type;
			this.updateDeltasTouches(e);
			this.updatePrevTouches(e);
			e.preventDefault();
		},
		initialize() {
			const targetEl = document.querySelector(this.scrollContainerSelector) || document;
			if(this.isTouchDevice) {
				targetEl.addEventListener('touchstart', this.touchstartCb, {passive: false});
				targetEl.addEventListener('touchmove', this.touchmoveCb, {passive: false});
				targetEl.addEventListener('touchend', this.touchendCb, {passive: false});
			} else {
				targetEl.onwheel = this.onWheel;				
			}
		},
		addKeysEvents() {
			document.addEventListener("keyup", (event) => {
				if (event.keyCode === 37 || event.keyCode === 38) {
					this.handleScroll(-20, true);
				} else if (event.keyCode === 39 || event.keyCode === 40) {
					this.handleScroll(20, true);
				}
			});
		}
	},
	mounted() {
		this.initialize();
		this.addKeysEvents();
	}
}
</script>
